import { IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'

export const QUOTE_HIGHLIGHT = `
...on quoteHighlight_Entry {
  id
  typeHandle
  anchorId
  
  quote
  username
  position

  ${ IMAGE_MOBILE }
  ${ IMAGE_DESKTOP }
}
`